export var SENTRY_RELEASE = "8bcd77fc8137b2861ca40bf401b75e57b5410e21";
